import crud from '@/crud/form/form'
import resources from '../../resources'

import computed from './computed'
import data from './data'
import methods from './methods'
import validations from './validations'

export default {
  computed,
  data,
  methods,
  validations,
  resourcePath: 'v1/patient/settings/covenants',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/form/resources/index.js